import Api from './api';

const carsListRequest = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/cars', {
        headers: { Authorization: 'Bearer ' + access_token } ,
        params: query
    })
}

const getSingleCarByChassisRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/car/chassis', data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const getSingleCarRequest = async (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/car/' + id, { headers: { Authorization: 'Bearer ' + access_token } })
}

const createNewCarRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/car', data,  {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const carsAuctionsListRequest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/cars/auctions', {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const carsVesselsListRequest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/cars/vessels', {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const carsUploadDocumentsRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/uploads/documents', data,  {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const carsUploadPhotosRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/uploads/photos', data,  {
        headers: {
            Authorization: 'Bearer ' + access_token,
            'Content-Type': 'multipart/form-data'
        } ,
    })
}

const carsUploadVideosRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/uploads/videos', data,  {
        headers: {
            Authorization: 'Bearer ' + access_token,
        } ,
    })
}

const carsExportInExcelRequest = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/cars/excel', {
        headers: { Authorization: 'Bearer ' + access_token },
        params: query,
        responseType: 'blob',
    })
}

const carsRecFeeExportInExcelRequest = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/cars/recfee', {
        headers: { Authorization: 'Bearer ' + access_token },
        params: query,
        responseType: 'blob',
    })
}

const updateCarRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().put('/api/cars/' + data.id , data.query, { headers: { Authorization: 'Bearer ' + access_token } })
}

const deleteCarRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().delete('/api/car/' + id, {
        headers: {
            Authorization: 'Bearer ' + access_token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }

    })
}

const getCarMediaFilesRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/uploads/media/' + id, {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const deleteCarMediaFilesRequest = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().delete('/api/uploads/media',  { headers:
        {
            Authorization: 'Bearer ' + access_token,
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        params: query

    })
}

const reorderCarMediaFilesRequest = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().put('/api/uploads/order', query, {
        headers: { Authorization: 'Bearer ' + access_token }
    })
}

const getCarDocumentsRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/car/documents/' + id, {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const getCarMediaFilesZipRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/car/media/' + id, {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}
const triggerZohoBillRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/car/zoho/trigger/bill', data,  {
        headers: {
            Authorization: 'Bearer ' + access_token
        } ,
    })
}
const triggerZohoInvoiceRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/car/zoho/trigger/invoice', data,  {
        headers: {
            Authorization: 'Bearer ' + access_token
        } ,
    })
}


export default {
    carsListRequest,
    carsExportInExcelRequest,
    updateCarRequest,
    carsAuctionsListRequest,
    carsVesselsListRequest,
    carsUploadDocumentsRequest,
    carsUploadPhotosRequest,
    getSingleCarRequest,
    carsUploadVideosRequest,
    createNewCarRequest,
    getSingleCarByChassisRequest,
    deleteCarRequest,
    getCarMediaFilesRequest,
    deleteCarMediaFilesRequest,
    reorderCarMediaFilesRequest,
    getCarDocumentsRequest,
    carsRecFeeExportInExcelRequest,
    getCarMediaFilesZipRequest,
    triggerZohoBillRequest,
    triggerZohoInvoiceRequest
}



// WEBPACK FOOTER //
// ./src/api/apiCars.js